import { API_PREFIX } from "./api.constants";

export const DEPARTMENT_ENDPOINTS = {
  DEPARTMENTS: `${API_PREFIX}/departments`,
  DEPARTMENT_DETAIL: (deptId: number | string) => `${API_PREFIX}/departments/${deptId}`,
  DEPARTMENTS_EXPORT: `${API_PREFIX}/departments/export`,
  DEPARTMENTS_CUSTOM_FIELDS: `${API_PREFIX}/departments/custom-fields/`,
  DEPARTMENT_CUSTOM_FIELD_DETAIL: (definitionId: number | string) => `${API_PREFIX}/departments/custom-fields/${definitionId}`,
};